// app/javascript/controllers/markdown_controller.js
import { Controller } from "@hotwired/stimulus"
import { marked } from 'marked'

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.renderMarkdown()
  }

  renderMarkdown() {
    if (this.hasContentTarget) {
      const rawMarkdown = this.contentTarget.getAttribute("data-markdown")
      if (rawMarkdown) {
        this.contentTarget.innerHTML = marked.parse(rawMarkdown)
      }
    }
  }
}
